module.exports = __webpack_public_path__ + "img/logo3.e30d3b23.png";